import Link from "next/link";
import { ScoreRing } from "@/app/_components/verdict/ScoreRing";
import { scoreOutOf100 } from "@/lib/conditions/score-display";
import type { CompanionDownDayModule } from "@/lib/companion/home-model";

export function CompanionDownDayBlock({
  downDay,
}: {
  downDay: CompanionDownDayModule;
}) {
  const hasSuggestions =
    Boolean(downDay.bestDay) ||
    downDay.guides.length > 0 ||
    Boolean(downDay.festival);

  return (
    <section
      aria-labelledby="companion-down-day-heading"
      className="mt-3 rounded-sm border border-white/12 bg-navy p-4"
    >
      <h3
        id="companion-down-day-heading"
        className="font-serif text-[22px] leading-tight text-white"
      >
        {downDay.heading}
      </h3>

      <div className="mt-3 space-y-2">
        {downDay.bestDay ? (
          <Link
            href={downDay.bestDay.href}
            className="flex min-h-[48px] items-center justify-between gap-3 rounded-sm border border-white/10 bg-white/[0.06] px-3 py-2 no-underline hover:border-gold/45"
          >
            <span className="text-[13px] font-semibold text-white/82">
              Best day this week: {downDay.bestDay.weekday}
            </span>
            <ScoreRing
              score={scoreOutOf100(downDay.bestDay.score)}
              size={40}
              caption={null}
              numberColor="#FFFFFF"
            />
          </Link>
        ) : null}

        {downDay.guides.map((guide) => (
          <Link
            key={guide.slug}
            href={guide.href}
            className="flex min-h-[44px] items-center rounded-sm border border-white/10 bg-white/[0.04] px-3 py-2 text-[13px] font-semibold text-white/82 no-underline hover:border-gold/45 hover:text-gold-light"
          >
            Get to know {guide.name}
          </Link>
        ))}

        {downDay.festival ? (
          <Link
            href={downDay.festival.href}
            className="block min-h-[44px] rounded-sm border border-white/10 bg-white/[0.04] px-3 py-3 no-underline hover:border-gold/45"
          >
            <span className="block text-[13px] font-semibold text-white/82">
              On nearby: {downDay.festival.name} · {downDay.festival.datesLabel}
            </span>
            {downDay.festival.score !== null || downDay.festival.state ? (
              <span className="mt-2 flex items-center gap-2">
                <ScoreRing
                  score={downDay.festival.score === null ? null : scoreOutOf100(downDay.festival.score)}
                  size={40}
                  caption={null}
                  numberColor="#FFFFFF"
                />
                {downDay.festival.state ? (
                  <span className="text-[12px] font-semibold text-white/70">
                    {downDay.festival.state}
                  </span>
                ) : null}
              </span>
            ) : null}
          </Link>
        ) : null}

        {!hasSuggestions ? (
          <Link
            href={downDay.href}
            className="flex min-h-[44px] items-center rounded-sm border border-white/10 bg-white/[0.04] px-3 py-2 text-[13px] font-semibold text-white/82 no-underline hover:border-gold/45 hover:text-gold-light"
          >
            {downDay.fallbackLinkLabel}
          </Link>
        ) : null}
      </div>
    </section>
  );
}
